export const requestActionPostfix = 'Request';
export const errorActionPostfix = 'Error';
export const cleanActionPostfix = 'Clean';
export const successActionPostfix = 'Success';
